"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotDocumentsTab = void 0;
var react_1 = __importDefault(require("react"));
var file_uploader_1 = require("../../../controls/file/file_uploader");
var LotDocumentsTab = function (props) {
    var lot_entity_id = props.lot_entity_id;
    return (react_1.default.createElement("div", { className: "flex flex-col w-full p-4" }, lot_entity_id ? (react_1.default.createElement("div", { className: "flex flex-col space-y-4" },
        react_1.default.createElement(file_uploader_1.FileUploaderControl, { lot_entity_id: lot_entity_id, type: "Document" }))) : (react_1.default.createElement("div", { className: "flex flex-col space-y-4" }, "You should create the lot under the details tab first, before uploading documents."))));
};
exports.LotDocumentsTab = LotDocumentsTab;
